import { useQuery } from '@apollo/client';
import { graphql } from '@app/graphql/types';
import { BannerPlatform } from '@app/graphql/types/graphql';

const QUERY = graphql(`
  query storefront_getAvailableTopBanner($companyId: ID!, $filter: AvailableTopBannerFilter!) {
    storefront_getAvailableTopBanner(companyId: $companyId, filter: $filter) {
      id
      title
      description
      startTime
      endTime
      isActive
      platforms
      backgroundColor
    }
  }
`);

export default function useTopBanners(companyId: string, filter: { platforms: BannerPlatform }) {
  return useQuery(QUERY, {
    variables: {
      companyId: companyId,
      filter,
    },
  });
}
